@if (
  (FeatureName.WilsonAI | featurePure | async) &&
  ('portal-shift-optimizer' | featureFlagPure | async) &&
  !isLoadingUsers
) {
  <wilson-assign-all-shifts-with-activities-button-view
    [isLoading]="isLoadingDraftMode"
    (createAssignmentJob)="createAssignmentJob()"
    (openOptimizerSettingsDrawer)="
      assignAllShiftsButtonService.renderAssignmentOptimizerDrawer(true)
    "
  ></wilson-assign-all-shifts-with-activities-button-view>
}
@if (assignAllShiftsButtonService.isAssignmentOptimizerDrawerVisible$ | async) {
  <wilson-assignment-optimizer-settings-drawer></wilson-assignment-optimizer-settings-drawer>
}
